import React, { useReducer, useState } from 'react';
import { HeaderStateContext } from '../context/header-state-context';
import { NAV_BAR_ACTIONS, NAV_BAR_INITIAL_STATE, navBarReducer } from '../reducers/nav-bar-reducer';
import { jsx as _jsx } from "react/jsx-runtime";
export var HeaderStateContextProvider = function HeaderStateContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      isNavDrawerOpen = _useState[0],
      setIsNavDrawerOpen = _useState[1];

  var _useReducer = useReducer(navBarReducer, NAV_BAR_INITIAL_STATE),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var selectItem = function selectItem() {
    var selectedItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    dispatch({
      selectedItem: selectedItem,
      type: NAV_BAR_ACTIONS.SET_ACTIVE_ITEM
    });
  };

  var resetNavBarState = function resetNavBarState() {
    return dispatch({
      selectedItem: '',
      type: NAV_BAR_ACTIONS.RESET_STATE
    });
  };

  var openNavDrawer = function openNavDrawer() {
    document.body.classList.add('overflow-hidden');
    setIsNavDrawerOpen(true);
  };

  var closeNavDrawer = function closeNavDrawer() {
    document.body.classList.remove('overflow-hidden');
    selectItem();
    setIsNavDrawerOpen(false);
  };

  return /*#__PURE__*/_jsx(HeaderStateContext.Provider, {
    value: {
      activeItem: state.activeItem,
      closeNavDrawer: closeNavDrawer,
      isNavDrawerOpen: isNavDrawerOpen,
      openNavDrawer: openNavDrawer,
      selectItem: selectItem,
      resetNavBarState: resetNavBarState,
      shouldAnimate: state.shouldAnimate
    },
    children: children
  });
};